export const AuthMedicaMenors = ({ auth, handleChange, error }) => {

  return (<>
    <br />
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització mèdica
        </h4>
        <p>
          <input type="checkbox" id="authMedica" name="authMedica" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authMedica"> AUTORITZO en cas que es produís una urgència mèdica imprevista greu i l'Institut l'hagués d'acompanyar a un centre mèdic, mentre no arriba la família, autoritzo el professor acompanyant a prendre totes les decisions oportunes (proves, anàlisis, transfusions ...). </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>
      </div>
    </div>

    <br />
  </>)
}

export const AuthMedica = ({ auth, handleChange, error }) => {

  return (<>
    <br />
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització mèdica
        </h4>
        <p>
          <input type="checkbox" id="authMedica" name="authMedica" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authMedica"> AUTORITZO a informar a la família en cas de necessitat mèdica
          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>
      </div>
    </div>

    <br />
  </>)
}
